import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, Users, Brain, MapPin, MessageCircle, BarChart3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const LandingPricing = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-muted/30 to-background">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">{t('landing.pricing.title')}</h2>
          <p className="text-xl text-muted-foreground">{t('landing.pricing.subtitle')}</p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {(t('landing.pricing.features', { returnObjects: true }) as Array<{title: string, description: string}>).map((feature, index) => {
            const icons = [CheckCircle, Users, Brain, MapPin, MessageCircle, BarChart3];
            const Icon = icons[index] || CheckCircle;
            
            return (
              <Card key={index} className="hover-scale border-border bg-background/80 backdrop-blur-sm">
                <CardContent className="p-6">
                  <div className="w-8 h-8 mb-4 rounded-lg bg-gradient-to-r from-emerald-400 to-cyan-400 flex items-center justify-center">
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">{feature.title}</h3>
                  <p className="text-sm text-muted-foreground">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};